(function ($) {
	// On Dom Ready
	$(function () {
		$('.btn-toggle-search').on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$('.search-fields-wrapper').slideToggle();
		});
	});
})(jQuery);
